$(function () {
	$("#navMainMobileToggle").on("click", function () {
		var toggleId = $(this).data("toggle");
		$(toggleId).toggleClass("open");
		$(this).toggleClass("open");
	});

	$(".content-sections.collapse > .item").on("click", function () {
		var thisId = $(this).attr("id");
		$("#" + thisId).toggleClass("open");
	});

	// Report mediastructure functions
	$(".list-media > .item.node-folder").on("click", function (e) {
		e.stopPropagation();
		console.log($(this).attr("id"));
		$(this).toggleClass("open");
	});

	$("#toggleAllFolders").on("click", function () {
		$('.list-media .item.node-folder').toggleClass("open");
	});
	// End Report mediastructures


	// ICTemplate functions
	$(".ict-sec-headline").on("click", function () {
		if (!$(this).hasClass("showvalue") && !$(this).hasClass("non-collapsible")) {
			$(this).parent(".ict-section:not(.empty)").toggleClass("open");
		}
	});

	$(".ict-section-headline").on("click", function (e) {

		if (!$(this).hasClass("empty")) {
			//find the linked section set to toggle
			var thisId = "#" + $(this).attr("id")
			var sectionSetId = thisId + "_Set";
			$(sectionSetId).toggleClass("open");

			// get current state of sectionset
			var isOpen = $(sectionSetId).hasClass("open");

			// also indicate open-state on the clicked element
			if (isOpen) {
				$(this).addClass("open");
				scrollToTargetId(thisId);
			} else {
				$(this).removeClass("open");
			}		

		}
	});

	$(".section-open-all").on("click", function () {
		$('.ict-section').each(function () {
			var sec = $(this);
			if (!sec.hasClass("empty") && !sec.hasClass("non-collapsible") && !sec.hasClass("headline-only")) {
				sec.toggleClass("open");
			}
		});
	});

	$(".section-close-all").on("click", function () {
		closeAllContentSections();
		//$('.ict-section').each(function () {
		//	var sec = $(this);
		//	if (!sec.hasClass("empty") && !sec.hasClass("non-collapsible") && !sec.hasClass("headline-only") && sec.hasClass("open")) {
		//		sec.toggleClass("open");
		//	}
		//});
	});

	$(".section-set-toggle").on("click", function () {
		$('.ict-section-headline').each(function () {
			if (!$(this).hasClass("empty")) {
				$(this).toggleClass("open");
			}
		});
		$('.ict-section-set').each(function () {
			var sec = $(this);
			if (!sec.hasClass("empty") && !sec.hasClass("non-collapsible") && !sec.hasClass("headline-only")) {
				sec.toggleClass("open");
			}
		});
	});

	$('.nav-page-areas .item-link').on('click', function (e) {
		// prevent the normal scrolling
		e.preventDefault();

		// make sure all content sections are closed first
		closeAllContentSections();

		// then open again only the requested one
		var btn = $(this);
		var btnTargetId = btn.attr("href");
		var mainSectionHeading = $(btnTargetId);
		$(btnTargetId).toggleClass("open");
		$(btnTargetId + "_Set").toggleClass("open");

		// scroll to target
		scrollToTargetId(btnTargetId);

		console.log("Shortcut clicked: " + btnTargetId);
		console.log($(mainSectionHeading));
	});

	//TopOfPageLink
	var lastScrollTop = 0;
	$(window).scroll(function () {
		var scrollTop = $(this).scrollTop();
		if (scrollTop <= 300) {
			$('#linkTop').removeClass("show").addClass("hide");
		} else {
			$('#linkTop').removeClass("hide").addClass("show");
		}
		lastScrollTop = scrollTop;
	});

	function scrollToTargetId(tgtId) {
		if (typeof tgtId !== 'undefined') {
			var scrollPosTop = $(tgtId).offset().top - 50;
			$('html, body').animate({scrollTop: scrollPosTop},	500);
		}
	}

	function closeAllContentSections() {
		$('.ict-section-headline.open').removeClass("open");
		$('.ict-section-set.open').removeClass("open");
		$('.ict-section.open').removeClass("open");
	}
});


